export const CITY_NAMES = {
    RU: {
        "71-np": "71 НП",
        "a-coruna": "Ла-Корунья",
        "aachen": "Ахен",
        "aalen": "Аален",
        "aarau": "Аарау",
        "aarhus": "Орхус",
        "abeokuta": "Абеокута",
        "abu-dhabi": "Абу-Даби",
        "abuja": "Абуджа",
        "achim": "Ахим",
        "adalar": "Адалар",
        "addis-ababa": "Аддис-Абеба",
        "adeje": "Адехе",
        "aguleri": "Агулери",
        "ainabkoi-olare-ward": "Айнабкой / приход Оларе",
        "aix-en-provence": "Экс-ан-Прованс",
        "al-jazeera-heritage-village": "Деревня наследия Аль-Джазиры",
        "al-jazeera-rak": "Аль-Джазира РАК",
        "al-minya": "Аль Минья",
        "alacant-alicante": "Алакант / Аликанте",
        "alanya": "Аланья",
        "alexandria": "Александрия",
        "alicante": "Аликанте",
        "almaty": "Алматы",
        "almere": "Алмере",
        "almetyevsk": "Альметьевск",
        "almunecar": "Альмуньекар",
        "alto-paraiso-de-goias": "Альто Параисо де Гояс",
        "amherst": "Амхерст",
        "ampfing": "Ампфинг",
        "amstelveen": "Амстелвен",
        "amsterdam": "Амстердам",
        "andijan": "Андижан",
        "angren": "Ангрен",
        "ann-arbor": "Анн-Арбор",
        "annapolis": "Аннаполис",
        "annecy": "Анси",
        "antibes": "Антибы",
        "antwerp": "Антверпен",
        "apeldoorn": "Апелдорн",
        "appenzell": "Аппенцелль",
        "arnhem": "Арнем",
        "arusha": "Аруша",
        "astana": "Астана",
        "athens": "Афины",
        "atlanta": "Атланта",
        "austin": "Остин",
        "baar": "Баар",
        "bad-homburg-vor-der-hohe": "Бад-Гомбург-фор-дер-Хёэ",
        "bad-schonborn": "Бад-Шенборн",
        "baden": "Баден",
        "baden-baden": "Баден-Баден",
        "bagerhat": "Багерхат",
        "baku": "Баку",
        "bakı": "Баку",
        "balchik": "Балчик",
        "bangkok": "Бангкок",
        "banjulinding": "Баньюлиндинг",
        "bar": "Бар",
        "barabanki": "Барабанки",
        "barcelona": "Барселона",
        "bari": "Бари",
        "barnawa": "Барнава",
        "barranquilla": "Барранкилья",
        "barrie": "Барри",
        "basel": "Базель",
        "batumi": "Батуми",
        "belda": "Бельда",
        "belgorod": "Белгород",
        "belgrad": "Белград",
        "belgrade": "Белград",
        "bender": "Бендеры",
        "bengaluru": "Бангалор",
        "benin-city": "Бенин Сити",
        "bergen": "Берген",
        "berkeley": "Беркли",
        "berlin": "Берлин",
        "bern": "Берн",
        "bhopal": "Бхопал",
        "biberach-an-der-riß": "Биберах-ан-дер-Рисс",
        "bien-hoa": "Бьен Хоа",
        "bilbao": "Бильбао",
        "bishkek": "Бишкек",
        "bladel": "Блейдел",
        "bloemfontein": "Блумфонтейн",
        "bochum": "Бохум",
        "bogota": "Богота",
        "boise": "Бойсе",
        "bonn": "Бонн",
        "bordeaux": "Бордо",
        "boreti": "Борети",
        "borgo-san-dalmazzo": "Борго Сан Далмаццо",
        "boston": "Бостон",
        "brake": "Тормоз",
        "braunschweig": "Брауншвейг",
        "bree": "Бри",
        "breme": "Бреме",
        "bremen": "Бремен",
        "bremerton": "Бремертон",
        "bridgwater": "Бриджуотер",
        "brighton": "Брайтон",
        "brisbane": "Брисбен",
        "brookline": "Бруклин",
        "brunswick": "Брансуик",
        "brussels": "Брюссель",
        "bruxelles": "Брюссель",
        "bucharest": "Бухарест",
        "budapest": "Будапешт",
        "budva": "Будва",
        "buenos-aires": "Буэнос-Айрес",
        "buenos-aires-chico": "Буэнос-Айрес Чико",
        "burlingame": "Берлингейм",
        "caba": "Каба",
        "cairo": "Каир",
        "calgary": "Калгари",
        "california": "Калифорния",
        "california-city": "Калифорния-Сити",
        "cambridge": "Кембридж",
        "campbell": "Кэмпбелл",
        "campione-d-italia": "Кампионе д'Италия",
        "canggu": "Чангу",
        "canmore": "Кенмор",
        "cape-town": "Кейптаун",
        "caracas": "Каракас",
        "cardiff": "Кардифф",
        "cartagena": "Картахена",
        "cary": "Кэри",
        "casablanca": "Касабланка",
        "cascais": "Кашкайш",
        "castello-de-la-plana": "Кастельо-де-ла-Плана",
        "castelo-branco": "Каштелу-Бранку",
        "celina": "Селина",
        "celle": "Целле",
        "central": "Центральный",
        "chambesy": "Шамбези",
        "champery": "Шампери",
        "charlotte": "Шарлотта",
        "cheboksary": "Чебоксары",
        "chekhov": "Чехов",
        "chelmsford": "Челмсфорд",
        "chelyabinsk": "Челябинск",
        "chemnitz": "Хемниц",
        "chene-bougeries": "Шен-Бужери",
        "chennai": "Ченнаи",
        "chernogolovka": "Черноголовка",
        "chhatrapati-sambhajinagar": "Чхатрапати Самбхаджинагар",
        "chiang-mai": "Чиангмай",
        "chicago": "Чикаго",
        "city-of-edinburgh": "Город Эдинбург",
        "city-of-london": "Лондонский Сити",
        "city-of-novi-sad": "Город Нови Сад",
        "city-of-westminster": "Город Вестминстер",
        "ciudad-de-lazaro-cardenas": "Сьюдад-де-Ласаро Карденас",
        "ciudad-universitaria": "Сьюдад-Университетария",
        "claremont": "Клермонт",
        "clarendon-hills": "Кларендон Хиллз",
        "cobh": "Кобх",
        "colima": "Колима",
        "cologne": "Кёльн",
        "columbia": "Колумбия",
        "comuna-de-colonia-bremen": "Комуна де Колония Бремен",
        "copenhagen": "Копенгаген",
        "coral-gables": "Корал Гейблс",
        "corsier-ge": "Корсье GE",
        "cottbus": "Котбус",
        "county-galway": "Графство Голуэй",
        "coventry": "Ковентри",
        "crans-montana": "Кран-Монтана",
        "cuautitlan-izcalli": "Куаутитлан Искалли",
        "cysoing": "Цизоинг",
        "czestochowa": "Ченстохова",
        "dachau": "Дахау",
        "dacorum": "Дакорум",
        "dakar": "Дакар",
        "dallas": "Даллас",
        "dammam": "Даммам",
        "danbury": "Дэнбери",
        "dandot-rs": "Дандо РС",
        "darmstadt": "Дармштадт",
        "davao-city": "Давао Сити",
        "daytona-beach": "Дейтона-Бич",
        "delft": "Делфт",
        "delhi": "Дели",
        "denia": "Дения",
        "denpasar": "Денпасар",
        "denpasar-utara": "Денпасар Утара",
        "derbent": "Дербент",
        "destin": "Дестин",
        "dhaka": "Дакка",
        "doha": "Доха",
        "dolgoprudny": "Dolgoproudny",
        "dornach": "Дорнах",
        "dortmund": "Дортмунд",
        "downtown-dubai": "центр Дубая",
        "dreieichenhain": "Драйайхенхайн",
        "dresden": "Дрезден",
        "dubai": "Дубай",
        "dubai-international-financial-centre": "Дубайский международный финансовый центр",
        "dublin": "Дублин",
        "dubna": "Дубна",
        "duisburg": "Дуйсбург",
        "durham": "Дарем",
        "dushanbe": "Душанбе",
        "dusseldorf": "Дюссельдорф",
        "eastbourne": "Истборн",
        "eau-claire": "О Клэр",
        "ecublens-vd": "Экубленс В.Д.",
        "edinburgh": "Эдинбург",
        "eindhoven": "Эйндховен",
        "enschede": "Энсхеде",
        "ercolano": "Эрколано",
        "erfurt": "Эрфурт",
        "erin-osun": "Эрин-осун",
        "erlangen": "Эрланген",
        "es-bordes": "Эс Бордес",
        "eschborn": "Эшборн",
        "espoo": "Эспоо",
        "essen": "Эссен",
        "eugene": "Евгений",
        "everett": "Эверетт",
        "fairfield": "Фэрфилд",
        "falmouth": "Фалмут",
        "faro": "Фаро",
        "fergana": "Фергана",
        "fethiye": "Фетхие",
        "finance-center": "Финансовый центр",
        "florence": "Флоренция",
        "florida-city": "Флорида Сити",
        "forli": "Форли",
        "fort-collins": "Форт Коллинз",
        "fort-lauderdale": "Форт-Лодердейл",
        "fountain-valley": "Долина Фонтанов",
        "frankfurt": "Франкфурт",
        "frankfurt-am-main": "Франкфурт-на-Майне",
        "freiburg-im-breisgau": "Фрайбург-им-Брайсгау",
        "freising": "Фрайзинг",
        "fribourg": "Фрибур",
        "friedberg-hessen": "Фридберг (Гессен)",
        "fryazino": "Фрязино",
        "fuentes-de-andalucia": "Фуэнтес-де-Андалусия",
        "gaithersburg": "Гейтерсбург",
        "gateshead": "Гейтсхед",
        "gbelce": "Гбельце",
        "geneva": "Женева",
        "geneve": "Женева",
        "genoa": "Генуя",
        "gijon": "Хихон",
        "giza": "Гиза",
        "glasgow": "Глазго",
        "gondal": "Гондал",
        "gothenburg": "Гетеборг",
        "gottingen": "Геттинген",
        "grays": "Серые",
        "graz": "Грац",
        "greater-tubatse-local-municipality": "Местный муниципалитет Большого Тубаце",
        "greifswald": "Грайфсвальд",
        "grenoble": "Гренобль",
        "grocka-urban-municipality": "Городской муниципалитет Гроцка",
        "groningen": "Гронинген",
        "guildford": "Гилфорд",
        "gvardeysk": "Гвардейск",
        "gwangju": "Кванджу",
        "gweru": "Гверу",
        "habaraduwa": "Хабарадува",
        "haifa": "Хайфа",
        "halle-saale": "Галле (Заале)",
        "hamburg": "Гамбург",
        "hamilton": "Гамильтон",
        "hannover": "Ганновер",
        "hanoi": "Ханой",
        "hanover": "Ганновер",
        "harare": "Хараре",
        "hasselt": "Хасселт",
        "hayward": "Хейворд",
        "heidelberg": "Гейдельберг",
        "heilbronn": "Хайльбронн",
        "helsinki": "Хельсинки",
        "herceg-novi": "Герцег-Нови",
        "herzliya": "Герцлия",
        "highland-park": "Хайленд Парк",
        "hildesheim": "Хильдесхайм",
        "hilversum": "Хилверсюм",
        "hiroshima": "Хиросима",
        "ho-chi-minh-city": "Хошимин",
        "hof-hasharon-regional-council": "Региональный совет Хоф ха-Шарон",
        "holyoke": "Холиок",
        "homel": "Гомель",
        "hong-kong": "Гонконг",
        "hoofddorp": "Хофддорп",
        "horsham": "Хоршам",
        "houston": "Хьюстон",
        "hue": "Хуэ",
        "hull": "Халл",
        "hyderabad": "Хайдарабад",
        "ibadan": "Ибадан",
        "ilmenau": "Ильменау",
        "indi": "Инди",
        "indore": "Индаур",
        "ingelheim-am-rhein": "Ингельхайм-на-Рейне",
        "innopolis": "Иннополис",
        "innsbruck": "Инсбрук",
        "ipapo": "Ипапо",
        "irkutsk": "Иркутск",
        "iseyin": "Исейн",
        "islamabad": "Исламабад",
        "istanbul": "Стамбул",
        "itala": "Итала",
        "ivanovo": "Иваново",
        "izhevsk": "Ижевск",
        "jacksonville": "Джексонвилл",
        "jaipur-municipal-corporation": "Муниципальная корпорация Джайпура",
        "jakarta": "Джакарта",
        "jambur-indonesia": "Джамбур Индонезия",
        "jeddah": "Джидда",
        "jersey-city": "Джерси-Сити",
        "jerusalem": "Иерусалим",
        "johannesburg": "Йоханнесбург",
        "julich": "Юлих",
        "jurmala": "Юрмала",
        "kadıkoy": "Кадыкёй",
        "kaiserslautern": "Кайзерслаутерн",
        "kaliningrad": "Калининград",
        "kampala": "Кампала",
        "kansas-city": "Канзас-Сити",
        "karachi": "Карачи",
        "karlsruhe": "Карлсруэ",
        "karshi": "Карши",
        "kassel": "Кассель",
        "kathmandu": "Катманду",
        "kathu": "Кату",
        "kaunas": "Каунас",
        "kazan": "Казань",
        "kemerovo": "Кемерово",
        "kenmore": "Кенмор",
        "kent": "Кент",
        "kiel": "Киль",
        "kigali": "Кигали",
        "kirchen-sieg": "Кирхен (Зиг)",
        "kirkland": "Киркланд",
        "kislovodsk": "Кисловодск",
        "kitab": "Китаб",
        "kitchener": "Китченер",
        "klagenfurt": "Клагенфурт",
        "knivsta": "Книвста",
        "ko-samui": "Ко Самуи",
        "koblenz": "Кобленц",
        "kokand": "Коканд",
        "koln": "Кёльн",
        "komsomolsk-on-amur": "Комсомольск-на-Амуре",
        "konstanz": "Констанц",
        "korolyov": "Королев",
        "kostroma": "Кострома",
        "krakow": "Краков",
        "krasnodar": "Краснодар",
        "krasnogorsk": "Красногорск",
        "krasnoyarsk": "Красноярск",
        "kuala-lumpur": "Куала-Лумпур",
        "kuala-selangor": "Куала Селангор",
        "kuopio": "Куопио",
        "kupres-rs-municipality": "Муниципалитет Купрес (РС)",
        "kyiv": "Киев",
        "kzengi": "Кзенги",
        "kzyl-bajrak": "Кзыл-Байрак",
        "l-aquila": "Л'Акуила",
        "la-ceiba": "Ла-Сейба",
        "la-punt-chamues-ch": "Ла-Пунт-Шамю-ш",
        "laane-harju-vald": "Ляэне-Харьюский валд",
        "ladenburg": "Ладенбург",
        "lagos": "Лагос",
        "laguna-hills": "Лагуна Хиллз",
        "lahore": "Лахор",
        "langenbach": "Лангенбах",
        "langenfeld": "Лангенфельд",
        "larnaca": "Ларнака",
        "las-palmas-de-gran-canaria": "Лас-Пальмас-де-Гран-Канария",
        "las-vegas": "Лас-Вегас",
        "laufen": "Лауфен",
        "lausanne": "Лозанна",
        "legian": "Легиан",
        "leh": "Лех",
        "leipzig": "Лейпциг",
        "leoben": "Леобен",
        "lesa": "Леза",
        "leuven": "Левен",
        "lilienthal": "Лилиенталь",
        "lille": "Лилль",
        "lima": "Лима",
        "limassol": "Лимассол",
        "limassol-municipality": "Муниципалитет Лимассола",
        "linkoping": "Линчепинг",
        "lipezk": "Липецк",
        "lisboa": "Лиссабон",
        "lisbon": "Лиссабон",
        "ljubljana": "Любляна",
        "lobnya": "Лобня",
        "london": "Лондон",
        "los-angeles": "Лос-Анджелес",
        "los-gatos": "Лос Гатос",
        "loudon": "Лаудон",
        "loxstedt": "Локсстедт",
        "lucerne": "Люцерн",
        "lucknow": "Лакнау",
        "lugano": "Лугано",
        "lund": "Лунд",
        "luneburg": "Люнебург",
        "luxembourg": "Люксембург",
        "lviv": "Львов",
        "lytkarino": "Лыткарино",
        "lyubertsy": "Люберцы",
        "madison": "Мэдисон",
        "madrid": "Мадрид",
        "magnitogorsk": "Магнитогорск",
        "mainz": "Майнц",
        "malaga": "Малага",
        "malden": "Молден",
        "malmo": "Мальмё",
        "manchester": "Манчестер",
        "manhattan-beach": "Манхэттен-Бич",
        "manila": "Манила",
        "mannheim": "Мангейм",
        "mansfield": "Мэнсфилд",
        "maqawwarah": "Макаввара",
        "marina-del-rey": "Марина дель Рей",
        "marrakech": "Марракеш",
        "massachusetts-gore": "Массачусетс Гор",
        "medan": "Медан",
        "melbourne": "Мельбурн",
        "mellieha": "Меллиха",
        "merida": "Мерида",
        "metz": "Мец",
        "mexico": "Мексика",
        "mexico-city": "Мехико",
        "miami": "Майами",
        "milan": "Милан",
        "milton-keynes": "Милтон Кейнс",
        "milwaukee": "Милуоки",
        "mirzo-ulugbek": "Мирзо Улугбек",
        "modi-in-illit": "Модиин-Иллит",
        "mojacar": "Мохакар",
        "monaco": "Монако",
        "montabaur": "Монтабаур",
        "montevideo": "Монтевидео",
        "montijo": "Монтихо",
        "montreal": "Монреаль",
        "montreux": "Монтре",
        "morgantown": "Моргантаун",
        "moskau": "Москва",
        "moscou": "Москва",
        "moscow": "Москва",
        "mosrentgen": "Мосрентген",
        "mumbai": "Мумбаи",
        "munchen": "Мюнхен",
        "munich": "Мюнхен",
        "municipality-of-vrilissia": "Муниципалитет Врилиссии",
        "munster": "Мюнстер",
        "murnau-am-staffelsee": "Мурнау-ам-Штаффельзее",
        "muscat": "Маскат",
        "mytishchi": "Мытищи",
        "nadupatti": "Надупатти",
        "nairobi": "Найроби",
        "namangan": "Наманган",
        "naples": "Неаполь",
        "narromine-shire-council": "Совет Шира Нарромайн",
        "nashville": "Нэшвилл",
        "navi-mumbai": "Нави Мумбаи",
        "netanya": "Нетания",
        "neuchatel": "Невшатель",
        "neuhausen": "Нойхаузен",
        "new-city": "Новый город",
        "new-delhi": "Нью-Дели",
        "new-orleans": "Новый Орлеан",
        "new-york": "Нью-Йорк",
        "newark": "Ньюарк",
        "newcastle-city-council": "Городской совет Ньюкасла",
        "newfields": "Ньюфилдс",
        "newport-news": "Ньюпорт-Ньюс",
        "newton": "Ньютон",
        "nezahualcoyotl": "Несауалькойотль",
        "nha-trang": "Нячанг",
        "nice": "Хороший",
        "nicosia": "Никосия",
        "nijmegen": "Неймеген",
        "nilufer": "Нилюфер",
        "nizhny-novgorod": "Нижний Новгород",
        "noginsk": "Ногинск",
        "noicattaro": "Нойкаттаро",
        "north-potomac": "Северный Потомак",
        "northampton": "Нортгемптон",
        "nossen": "Носсен",
        "nottingham": "Ноттингем",
        "novi-sad": "Нови Сад",
        "novocheboksarsk": "Новочебоксарск",
        "novosibirsk": "Новосибирск",
        "nuevo-mexico": "Нуэво-Мексико",
        "nuremberg": "Нюрнберг",
        "nurnberg": "Нюрнберг",
        "nyon": "Ньон",
        "obninsk": "Обнинск",
        "ocosingo": "Окосинго",
        "odesa": "Одесса",
        "odintsovo": "Одинцово",
        "ohio": "Огайо",
        "ohrid": "Охрид",
        "okinawa": "Окинава",
        "okres-brno-mesto": "okres Брно-место",
        "old-tappan": "Старый Таппан",
        "oldenburg": "Ольденбург",
        "olympia": "Олимпия",
        "onex": "Онекс",
        "onna": "Онна",
        "orange": "Апельсин",
        "orlando": "Орландо",
        "osaka": "Осака",
        "oshogbo": "Ошогбо",
        "oslo": "Осло",
        "osnabruck": "Оснабрюк",
        "osterholz-scharmbeck": "Остерхольц-Шармбек",
        "ostfildern": "Остфильдерн",
        "ottawa": "Оттава",
        "oxford": "Оксфорд",
        "oyo": "Ойо",
        "oyon": "Ойон",
        "oyten": "Ойтен",
        "paderborn": "Падерборн",
        "padua": "Падуя",
        "pafos": "Пафос",
        "palma-de-mallorca": "Пальма де Майорка",
        "palo-alto": "Пало-Альто",
        "pamukkale": "Памуккале",
        "pancevo": "Панчево",
        "paphos": "Пафос",
        "paris": "Париж",
        "pasadena": "Пасадена",
        "passau": "Пассау",
        "pavlovsky-posad": "Павловский Посад",
        "peliatan": "Пелиатан",
        "perm": "Пермь",
        "perugia": "Перуджа",
        "peshawar": "Пешавар",
        "petaling-jaya": "Петалинг Джая",
        "peterborough": "Питерборо",
        "pfafers": "Пфеферс",
        "philadelphia": "Филадельфия",
        "phoenix": "Финикс",
        "phuket": "Пхукет",
        "pisa": "Пиза",
        "piscataway-township": "Пискатауэй Тауншип",
        "pittsburgh": "Питтсбург",
        "playa-del-carmen": "Плайя дель Кармен",
        "podgorica": "Подгорица",
        "port-harcourt": "Порт-Харкорт",
        "portimao": "Портиман",
        "portland": "Портленд",
        "porto": "Порту",
        "porto-alegre": "Порту-Алегри",
        "portsmouth": "Портсмут",
        "potsdam": "Потсдам",
        "poznan": "Познань",
        "prague": "Прага",
        "praha": "Прага",
        "preston": "Престон",
        "prilep": "Прилеп",
        "princeton": "Принстон",
        "protvino": "Протвино",
        "pskov": "Псков",
        "puebla-city": "Пуэбла Сити",
        "pune": "Пуна",
        "punta-del-este": "Пунта-дель-Эсте",
        "pushchino": "Пущино",
        "pushkino": "Пушкино",
        "pyatigorsk": "Пятигорск",
        "płonina": "Плонина",
        "qarshi": "Карши",
        "qashqar-mahalla": "Кашкарская махалля",
        "queretaro": "Керетаро",
        "quincy": "Куинси",
        "quintana-roo": "Кинтана-Роо",
        "rabat": "Рабат",
        "rajkot": "Раджкот",
        "raleigh": "Роли",
        "ramat-gan": "Рамат-Ган",
        "ras-al-khaimah": "Рас-Аль-Хайма",
        "ratanpur": "Ратанпур",
        "reading": "Чтение",
        "redcar": "Редкар",
        "redmond": "Редмонд",
        "redondo-beach": "Редондо Бич",
        "regensburg": "Регенсбург",
        "reggio-nell-emilia": "Реджо-нель-Эмилия",
        "rehovot": "Реховот",
        "reisterstown": "Рейстерстаун",
        "reutlingen": "Ройтлинген",
        "richmond": "Ричмонд",
        "richmond-hill": "Ричмонд Хилл",
        "riga": "Рига",
        "rio-de-janeiro": "Рио-де-Жанейро",
        "rishon-lezion": "Ришон ле-Цион",
        "riyadh": "Эр-Рияд",
        "rochester": "Рочестер",
        "rome": "Рим",
        "romont-fr": "Ромонт, Франция",
        "roseville": "Розвилл",
        "rossano-veneto": "Россано Венето",
        "rostock": "Росток",
        "rostov-on-don": "Ростов-на-Дону",
        "rotterdam": "Роттердам",
        "rourkela": "Руркела",
        "rsovci": "Рсовци",
        "rue": "Рю",
        "ruza": "Руза",
        "ryazan": "Рязань",
        "rybinsk": "Рыбинск",
        "saarbrucken": "Саарбрюккен",
        "saavedra": "Сааведра",
        "sacramento": "Сакраменто",
        "saddle-river": "Седловая река",
        "safi": "Сафи",
        "saint-petersburg": "Санкт-Петербург",
        "salerno": "Салерно",
        "salt-lake-city": "Солт-Лейк-Сити",
        "samara": "Самара",
        "samarkand": "Самарканд",
        "san-carlos-de-bariloche": "Сан-Карлос-де-Барилоче",
        "san-diego": "Сан-Диего",
        "san-francisco": "Сан-Франциско",
        "san-isidro": "Сан-Исидро",
        "san-jose": "Сан-Хосе",
        "san-jose-de-ushua": "Сан-Хосе де Ушуа",
        "san-leandro": "Сан-Леандро",
        "san-marino": "Сан-Марино",
        "san-sebastian": "Сан-Себастьян",
        "santa-ana": "Санта Ана",
        "santa-barbara": "Санта-Барбара",
        "santa-clara": "Санта-Клара",
        "santa-cruz-de-la-sierra": "Санта-Крус-де-ла-Сьерра",
        "santiago": "Сантьяго",
        "santiago-de-queretaro": "Сантьяго де Керетаро",
        "sao-joao-estoril": "Сан-Жуан-ду-Эшторил",
        "sao-paulo": "Сан-Паулу",
        "sapporo": "Саппоро",
        "sarasota": "Сарасота",
        "satellite-beach": "Спутниковый пляж",
        "schaffhausen": "Шаффхаузен",
        "schaumburg": "Шаумбург",
        "schleswig": "Шлезвиг",
        "schwerin": "Шверин",
        "se": "Се",
        "seattle": "Сиэтл",
        "seeheim-jugenheim": "Зеехайм-Югенхайм",
        "senwabarwana": "Сенвабарвана",
        "seoul": "Сеул",
        "serpukhov": "Серпухов",
        "settat": "Сеттат",
        "sfax": "Сфакс",
        "shantou": "Шаньтоу",
        "sharjah": "Шарджа",
        "shenzhen": "Шэньчжэнь",
        "sherborn": "Шерборн",
        "siegen": "Зиген",
        "siena": "Сиена",
        "silchar": "Силчар",
        "simferopol": "Симферополь",
        "singapore": "Сингапур",
        "sisli": "Шишли",
        "skopje": "Скопье",
        "smolensk": "Смоленск",
        "sochi": "Сочи",
        "sofia": "София",
        "solingen": "Золинген",
        "somerville": "Сомервилл",
        "sopot": "Сопот",
        "squamish": "Сквомиш",
        "st-albans": "Сент-Олбанс",
        "st-gallen": "Санкт-Галлен",
        "st-louis": "Сент-Луис",
        "st-sulpice-vd": "Сен-Сюльпис VD",
        "stadtgebiet-bremen": "Штадтгебит Бремена",
        "staines-upon-thames": "Стейнс-апон-Темз",
        "stari-grad-urban-municipality": "Городской муниципалитет Стари Град",
        "stavanger": "Ставангер",
        "stavropol": "Ставрополь",
        "stockholm": "Стокгольм",
        "stralsund": "Штральзунд",
        "strasbourg": "Страсбург",
        "straubing": "Штраубинг",
        "stupino": "Ступино",
        "stuttgart": "Штутгарт",
        "sudbury": "Садбери",
        "sudwest-fryslan": "Юго-Фрислан",
        "sultan-bathery": "Султан Батери",
        "sunny-isles-beach": "Санни-Айлс-Бич",
        "sunnyvale": "Саннивейл",
        "surgut": "Сургут",
        "suwon": "Сувон",
        "svetlogorsk": "Светлогорск",
        "swansea": "Суонси",
        "swindon": "Суиндон",
        "sydney": "Сидней",
        "taguig": "Тагиг",
        "taipei": "Тайбэй",
        "taiwang": "Тайвань",
        "tallinn": "Таллинн",
        "tampa": "Тампа",
        "tampere": "Тампере",
        "tashkent": "Ташкент",
        "tbilisi": "Тбилиси",
        "teays-valley": "Чайная долина",
        "tehran": "Тегеран",
        "tel-aviv": "Тель-Авив",
        "tel-izhak": "Тель Ицхак",
        "termez": "Термез",
        "terrassa": "Террасса",
        "tertry": "Тертри",
        "texas-city": "Техас Сити",
        "thanh-pho-ho-chi-minh": "Тхань Пхо Хо Ши Мин",
        "the-hague": "Гаага",
        "theoule-sur-mer": "Теуль-сюр-Мер",
        "thonon-les-bains": "Тонон-ле-Бен",
        "three-rivers": "Три реки",
        "thuwal": "Тувал",
        "tibubeneng": "Тибубененг",
        "tilburg": "Тилбург",
        "tirana": "Тирана",
        "titel-municipality": "Титульный муниципалитет",
        "tivat": "Тиват",
        "tlalnepantla": "Тлалнепантла",
        "togliatti": "Тольятти",
        "tokyo": "Токио",
        "tolyatti": "Тольятти",
        "tonisvorst": "Тёнисворст",
        "toronto": "Торонто",
        "torres-vedras": "Торреш Ведрас",
        "torrevieja": "Торревьеха",
        "toshkent": "Ташкент",
        "toulon": "Тулон",
        "toulouse": "Тулуза",
        "town-of-eastchester": "Город Истчестер",
        "tres-arroyos": "Трес Арройос",
        "trieste": "Триест",
        "tubingen": "Тюбинген",
        "tulsa": "Талса",
        "tunis": "Тунис",
        "turin": "Турин",
        "tuscania": "Тускания",
        "tver": "Тверь",
        "twin-falls": "Твин Фолс",
        "tyumen": "Тюмень",
        "ua-pou": "Уа Поу",
        "ubud": "Убуд",
        "udine-udin": "Удине / Удин",
        "ufa": "Уфа",
        "ulaanbaatar": "Улан-Батор",
        "ulm": "Ульм",
        "upper-darby": "Аппер Дарби",
        "uppsala": "Уппсала",
        "urgench": "Ургенч",
        "us": "Нас",
        "us-coast-guard-reservation": "Резервация береговой охраны США",
        "ussy": "Усси",
        "utrecht": "Утрехт",
        "uttar-mohal": "Уттар Мохал",
        "uyo": "Уйо",
        "uz": "Уз",
        "uzbekistan": "Узбекистан",
        "vaasa": "Вааса",
        "vadodara": "Вадодара",
        "valencia": "Валенсия",
        "vancouver": "Ванкувер",
        "vannes": "Ванн",
        "varna": "Варна",
        "vaughan": "Вон",
        "veldhoven": "Вельдховен",
        "veliko-tarnovo": "Велико Тырново",
        "veliky-novgorod": "Великий Новгород",
        "venezia": "Венеция",
        "veracruz-city": "Веракрус Сити",
        "vienna": "Вена",
        "vigo": "Виго",
        "villers-brulin": "Виллер-Брюлен",
        "vilnius": "Вильнюс",
        "viru-nigula": "Виру-Нигула",
        "visp": "Висп",
        "vista-hermosa": "Виста Эрмоса",
        "vladikavkaz": "Владикавказ",
        "vladimir": "Владимир",
        "vojvodinci": "Воеводинцы",
        "vologda": "Вологда",
        "voronezh": "Воронеж",
        "vozdovac-urban-municipality": "Городской муниципалитет Воздовац",
        "walldorf": "Вальдорф",
        "warsaw": "Варшава",
        "warwick": "Уорик",
        "washington": "Вашингтон",
        "wassenaar": "Вассенаар",
        "waverley": "Уэверли",
        "weiterstadt": "Вайтерштадт",
        "wesel": "Везель",
        "west-jerusalem": "Западный Иерусалим",
        "west-oxfordshire": "Западный Оксфордшир",
        "wien": "Вена",
        "wiesbaden": "Висбаден",
        "wilbraham": "Уилбрахам",
        "winnipeg": "Виннипег",
        "winterthur": "Винтертур",
        "woking": "Уокинг",
        "wolverhampton": "Вулвергемптон",
        "worms": "Черви",
        "woudenberg": "Вауденберг",
        "wrocław": "Вроцлав",
        "wurzburg": "Вюрцбург",
        "xi-an": "Сиань",
        "xorezm": "Хорезм",
        "yangibazar": "Янгибазар",
        "yangiyul": "Янгиюль",
        "yaroslavl": "Ярославль",
        "yekaterinburg": "Екатеринбург",
        "yerevan": "Ереван",
        "zagreb": "Загреб",
        "zelenograd": "Зеленоград",
        "zemun-urban-municipality": "Земунский городской муниципалитет",
        "zhukovsky": "Жуковский",
        "zollikerberg": "Золликерберг",
        "zug": "Цуг",
        "zurich": "Цюрих",
        "zvenigorod": "Звенигород",
        "đa-nang": "Да Нонг",
        "λαρνακα": "Λάρνακα",
        "λεμεσος": "Λεμεσός",
        "παφος": "Πάφος",
        "алматы": "Алматы",
        "алматы-ауылдық-округі": "Алматы ауылдық округі",
        "астана": "Астана",
        "белоградчик": "Белоградчик",
        "београд": "Београд",
        "бишкек": "Бишкек",
        "град-нови-сад": "Град Нови Сад",
        "градска-општина-вождовац": "Градска општина Вождовац",
        "градска-општина-земун": "Градска општина Земун",
        "долгопрудныи": "Долгопрудный",
        "душанбе": "Душанбе",
        "екатеринбург": "Екатеринбург",
        "ижевск": "Ижевск",
        "казань": "Казань",
        "калининград": "Калининград",
        "королев": "Королёв",
        "краснодар": "Краснодар",
        "краснознаменск": "Краснознаменск",
        "лобня": "Лобня",
        "менеуз-москва": "Менеуз-Москва",
        "моика": "Мойка",
        "москва": "Москва",
        "мытищи": "Мытищи",
        "нови-сад": "Нови Сад",
        "новосибирск": "Новосибирск",
        "одинцово": "Одинцово",
        "покровское": "Покровское",
        "ростов-на-дону": "Ростов-на-Дону",
        "самара": "Самара",
        "санкт-петербург": "Санкт-Петербург",
        "светлогорск": "Светлогорск",
        "светлыи": "Светлый",
        "смоленск": "Смоленск",
        "советск": "Советск",
        "софия": "София",
        "сочи": "Сочи",
        "тамбов": "Тамбов",
        "тбилисское-сельское-поселение": "Тбилисское сельское поселение",
        "тверь": "Тверь",
        "томск": "Томск",
        "ульяновск": "Ульяновск",
        "уфа": "Уфа",
        "ялта": "Ялта",
        "ярославль": "Ярославль",
        "әлжан-ана": "Әлжан ана",
        "երեւան": "Երևան",
        "חיפה": "חיפה",
        "ראשון-לציון": "ראשון לציון",
        "רחובות": "רחובות",
        "תל-אביב-יפו": "תל אביב–יפו",
        "ابو-ظبي": "أبو ظبي",
        "الدوحة": "الدوحة",
        "الرياض": "الرياض",
        "حدايق-الشيخ-محمد-بن-راشد-وادي-الصفا-1": "حدائق الشيخ محمد بن راشد/وادي الصفا 1",
        "دبي": "دبي",
        "راس-الخيمة": "رأس الخيمة",
        "ภเก-ต": "ภูเก็ต",
        "თბილისი": "თბილისი",
        "서울특별시": "서울특별시",
        "深圳市": "深圳市",
    },
    EN: {
        "71-np": "71 NP",
        "a-coruna": "A Coruña",
        "aachen": "Aachen",
        "aalen": "Aalen",
        "aarau": "Aarau",
        "aarhus": "Aarhus",
        "abeokuta": "Abeokuta",
        "abu-dhabi": "Abu Dhabi",
        "abuja": "Abuja",
        "achim": "Achim",
        "adalar": "Adalar",
        "addis-ababa": "Addis Ababa",
        "adeje": "Adeje",
        "aguleri": "Aguleri",
        "ainabkoi-olare-ward": "Ainabkoi/Olare ward",
        "aix-en-provence": "Aix-en-Provence",
        "al-jazeera-heritage-village": "Al jazeera heritage village",
        "al-jazeera-rak": "Al Jazeera RAK",
        "al-minya": "Al Minya",
        "alacant-alicante": "Alacant / Alicante",
        "alanya": "Alanya",
        "alexandria": "Alexandria",
        "alicante": "Alicante",
        "almaty": "Almaty",
        "almere": "Almere",
        "almetyevsk": "Almetyevsk",
        "almunecar": "Almuñécar",
        "alto-paraiso-de-goias": "Alto Paraíso de Goiás",
        "amherst": "Amherst",
        "ampfing": "Ampfing",
        "amstelveen": "Amstelveen",
        "amsterdam": "Amsterdam",
        "andijan": "Andijan",
        "angren": "Angren",
        "ann-arbor": "Ann Arbor",
        "annapolis": "Annapolis",
        "annecy": "Annecy",
        "antibes": "Antibes",
        "antwerp": "Antwerp",
        "apeldoorn": "Apeldoorn",
        "appenzell": "Appenzell",
        "arnhem": "Arnhem",
        "arusha": "Arusha",
        "astana": "Astana",
        "athens": "Athens",
        "atlanta": "Atlanta",
        "austin": "Austin",
        "baar": "Baar",
        "bad-homburg-vor-der-hohe": "Bad Homburg vor der Höhe",
        "bad-schonborn": "Bad Schönborn",
        "baden": "Baden",
        "baden-baden": "Baden-Baden",
        "bagerhat": "Bagerhat",
        "baku": "Baku",
        "bakı": "Bakı",
        "balchik": "Balchik",
        "bangkok": "Bangkok",
        "banjulinding": "Banjulinding",
        "bar": "Bar",
        "barabanki": "Barabanki",
        "barcelona": "Barcelona",
        "bari": "Bari",
        "barnawa": "Barnawa",
        "barranquilla": "Barranquilla",
        "barrie": "Barrie",
        "basel": "Basel",
        "batumi": "Batumi",
        "belda": "Belda",
        "belgorod": "Belgorod",
        "belgrad": "Belgrad",
        "belgrade": "Belgrade",
        "bender": "Bender",
        "bengaluru": "Bengaluru",
        "benin-city": "Benin City",
        "bergen": "Bergen",
        "berkeley": "Berkeley",
        "berlin": "Berlin",
        "bern": "Bern",
        "bhopal": "Bhopal",
        "biberach-an-der-riß": "Biberach an der Riß",
        "bien-hoa": "Biên Hòa",
        "bilbao": "Bilbao",
        "bishkek": "Bishkek",
        "bladel": "Bladel",
        "bloemfontein": "Bloemfontein",
        "bochum": "Bochum",
        "bogota": "Bogota",
        "boise": "Boise",
        "bonn": "Bonn",
        "bordeaux": "Bordeaux",
        "boreti": "Boreti",
        "borgo-san-dalmazzo": "Borgo San Dalmazzo",
        "boston": "Boston",
        "brake": "Brake",
        "braunschweig": "Braunschweig",
        "bree": "Bree",
        "breme": "Brême",
        "bremen": "Bremen",
        "bremerton": "Bremerton",
        "bridgwater": "Bridgwater",
        "brighton": "Brighton",
        "brisbane": "Brisbane",
        "brookline": "Brookline",
        "brunswick": "Brunswick",
        "brussels": "Brussels",
        "bruxelles": "Bruxelles",
        "bucharest": "Bucharest",
        "budapest": "Budapest",
        "budva": "Budva",
        "buenos-aires": "Buenos Aires",
        "buenos-aires-chico": "Buenos Aires Chico",
        "burlingame": "Burlingame",
        "caba": "Caba",
        "cairo": "Cairo",
        "calgary": "Calgary",
        "california": "California",
        "california-city": "California City",
        "cambridge": "Cambridge",
        "campbell": "Campbell",
        "campione-d-italia": "Campione d'Italia",
        "canggu": "Canggu",
        "canmore": "Canmore",
        "cape-town": "Cape Town",
        "caracas": "Caracas",
        "cardiff": "Cardiff",
        "cartagena": "Cartagena",
        "cary": "Cary",
        "casablanca": "Casablanca",
        "cascais": "Cascais",
        "castello-de-la-plana": "Castelló de la Plana",
        "castelo-branco": "Castelo Branco",
        "celina": "Celina",
        "celle": "Celle",
        "central": "Central",
        "chambesy": "Chambésy",
        "champery": "Champéry",
        "charlotte": "Charlotte",
        "cheboksary": "Cheboksary",
        "chekhov": "Chekhov",
        "chelmsford": "Chelmsford",
        "chelyabinsk": "Chelyabinsk",
        "chemnitz": "Chemnitz",
        "chene-bougeries": "Chêne-Bougeries",
        "chennai": "Chennai",
        "chernogolovka": "Chernogolovka",
        "chhatrapati-sambhajinagar": "Chhatrapati Sambhajinagar",
        "chiang-mai": "Chiang Mai",
        "chicago": "Chicago",
        "city-of-edinburgh": "City of Edinburgh",
        "city-of-london": "City of London",
        "city-of-novi-sad": "City of Novi Sad",
        "city-of-westminster": "City of Westminster",
        "ciudad-de-lazaro-cardenas": "Ciudad de Lazaro Cardenas",
        "ciudad-universitaria": "Ciudad Universitaria",
        "claremont": "Claremont",
        "clarendon-hills": "Clarendon Hills",
        "cobh": "Cobh",
        "colima": "Colima",
        "cologne": "Cologne",
        "columbia": "Columbia",
        "comuna-de-colonia-bremen": "Comuna de Colonia Bremen",
        "copenhagen": "Copenhagen",
        "coral-gables": "Coral Gables",
        "corsier-ge": "Corsier GE",
        "cottbus": "Cottbus",
        "county-galway": "County Galway",
        "coventry": "Coventry",
        "crans-montana": "Crans-Montana",
        "cuautitlan-izcalli": "Cuautitlán Izcalli",
        "cysoing": "Cysoing",
        "czestochowa": "Częstochowa",
        "dachau": "Dachau",
        "dacorum": "Dacorum",
        "dakar": "Dakar",
        "dallas": "Dallas",
        "dammam": "Dammam",
        "danbury": "Danbury",
        "dandot-rs": "Dandot RS",
        "darmstadt": "Darmstadt",
        "davao-city": "Davao City",
        "daytona-beach": "Daytona Beach",
        "delft": "Delft",
        "delhi": "Delhi",
        "denia": "Dénia",
        "denpasar": "Denpasar",
        "denpasar-utara": "Denpasar Utara",
        "derbent": "Derbent",
        "destin": "Destin",
        "dhaka": "Dhaka",
        "doha": "Doha",
        "dolgoprudny": "Dolgoprudny",
        "dornach": "Dornach",
        "dortmund": "Dortmund",
        "downtown-dubai": "downtown dubai",
        "dreieichenhain": "Dreieichenhain",
        "dresden": "Dresden",
        "dubai": "Dubai",
        "dubai-international-financial-centre": "Dubai International Financial Centre",
        "dublin": "Dublin",
        "dubna": "Dubna",
        "duisburg": "Duisburg",
        "durham": "Durham",
        "dushanbe": "Dushanbe",
        "dusseldorf": "Dusseldorf",
        "eastbourne": "Eastbourne",
        "eau-claire": "Eau Claire",
        "ecublens-vd": "Ecublens VD",
        "edinburgh": "Edinburgh",
        "eindhoven": "Eindhoven",
        "enschede": "Enschede",
        "ercolano": "Ercolano",
        "erfurt": "Erfurt",
        "erin-osun": "Erin-osun",
        "erlangen": "Erlangen",
        "es-bordes": "Es Bòrdes",
        "eschborn": "Eschborn",
        "espoo": "Espoo",
        "essen": "Essen",
        "eugene": "Eugene",
        "everett": "Everett",
        "fairfield": "Fairfield",
        "falmouth": "Falmouth",
        "faro": "Faro",
        "fergana": "Fergana",
        "fethiye": "Fethiye",
        "finance-center": "Finance Center",
        "florence": "Florence",
        "florida-city": "Florida City",
        "forli": "Forlì",
        "fort-collins": "Fort Collins",
        "fort-lauderdale": "Fort Lauderdale",
        "fountain-valley": "Fountain Valley",
        "frankfurt": "Frankfurt",
        "frankfurt-am-main": "Frankfurt am Main",
        "freiburg-im-breisgau": "Freiburg im Breisgau",
        "freising": "Freising",
        "fribourg": "Fribourg",
        "friedberg-hessen": "Friedberg (Hessen)",
        "fryazino": "Fryazino",
        "fuentes-de-andalucia": "Fuentes de Andalucía",
        "gaithersburg": "Gaithersburg",
        "gateshead": "Gateshead",
        "gbelce": "Gbelce",
        "geneva": "Geneva",
        "geneve": "Genève",
        "genoa": "Genoa",
        "gijon": "Gijón",
        "giza": "Giza",
        "glasgow": "Glasgow",
        "gondal": "Gondal",
        "gothenburg": "Gothenburg",
        "gottingen": "Göttingen",
        "grays": "Grays",
        "graz": "Graz",
        "greater-tubatse-local-municipality": "Greater Tubatse Local Municipality",
        "greifswald": "Greifswald",
        "grenoble": "Grenoble",
        "grocka-urban-municipality": "Grocka Urban Municipality",
        "groningen": "Groningen",
        "guildford": "Guildford",
        "gvardeysk": "Gvardeysk",
        "gwangju": "Gwangju",
        "gweru": "Gweru",
        "habaraduwa": "Habaraduwa",
        "haifa": "Haifa",
        "halle-saale": "Halle (Saale)",
        "hamburg": "Hamburg",
        "hamilton": "Hamilton",
        "hannover": "Hannover",
        "hanoi": "Hanoi",
        "hanover": "Hanover",
        "harare": "Harare",
        "hasselt": "Hasselt",
        "hayward": "Hayward",
        "heidelberg": "Heidelberg",
        "heilbronn": "Heilbronn",
        "helsinki": "Helsinki",
        "herceg-novi": "Herceg Novi",
        "herzliya": "Herzliya",
        "highland-park": "Highland Park",
        "hildesheim": "Hildesheim",
        "hilversum": "Hilversum",
        "hiroshima": "Hiroshima",
        "ho-chi-minh-city": "Ho Chi Minh City",
        "hof-hasharon-regional-council": "Hof HaSharon Regional Council",
        "holyoke": "Holyoke",
        "homel": "Homel",
        "hong-kong": "Hong Kong",
        "hoofddorp": "Hoofddorp",
        "horsham": "Horsham",
        "houston": "Houston",
        "hue": "Huế",
        "hull": "Hull",
        "hyderabad": "Hyderabad",
        "ibadan": "Ibadan",
        "ilmenau": "Ilmenau",
        "indi": "Indi",
        "indore": "Indore",
        "ingelheim-am-rhein": "Ingelheim am Rhein",
        "innopolis": "Innopolis",
        "innsbruck": "Innsbruck",
        "ipapo": "Ipapo",
        "irkutsk": "Irkutsk",
        "iseyin": "Iseyin",
        "islamabad": "Islamabad",
        "istanbul": "İstanbul",
        "itala": "Itala",
        "ivanovo": "Ivanovo",
        "izhevsk": "Izhevsk",
        "jacksonville": "Jacksonville",
        "jaipur-municipal-corporation": "Jaipur Municipal Corporation",
        "jakarta": "Jakarta",
        "jambur-indonesia": "Jambur Indonesia",
        "jeddah": "Jeddah",
        "jersey-city": "Jersey City",
        "jerusalem": "Jerusalem",
        "johannesburg": "Johannesburg",
        "julich": "Jülich",
        "jurmala": "Jūrmala",
        "kadıkoy": "Kadıköy",
        "kaiserslautern": "Kaiserslautern",
        "kaliningrad": "Kaliningrad",
        "kampala": "Kampala",
        "kansas-city": "Kansas City",
        "karachi": "Karachi",
        "karlsruhe": "Karlsruhe",
        "karshi": "Karshi",
        "kassel": "Kassel",
        "kathmandu": "Kathmandu",
        "kathu": "Kathu",
        "kaunas": "Kaunas",
        "kazan": "Kazan",
        "kemerovo": "Kemerovo",
        "kenmore": "Kenmore",
        "kent": "Kent",
        "kiel": "Kiel",
        "kigali": "Kigali",
        "kirchen-sieg": "Kirchen (Sieg)",
        "kirkland": "Kirkland",
        "kislovodsk": "Kislovodsk",
        "kitab": "Kitab",
        "kitchener": "Kitchener",
        "klagenfurt": "Klagenfurt",
        "knivsta": "Knivsta",
        "ko-samui": "Ko Samui",
        "koblenz": "Koblenz",
        "kokand": "Kokand",
        "koln": "Köln",
        "komsomolsk-on-amur": "Komsomolsk-on-Amur",
        "konstanz": "Konstanz",
        "korolyov": "Korolyov",
        "kostroma": "Kostroma",
        "krakow": "Krakow",
        "krasnodar": "Krasnodar",
        "krasnogorsk": "Krasnogorsk",
        "krasnoyarsk": "Krasnoyarsk",
        "kuala-lumpur": "Kuala Lumpur",
        "kuala-selangor": "Kuala Selangor",
        "kuopio": "Kuopio",
        "kupres-rs-municipality": "Kupres (RS) municipality",
        "kyiv": "Kyiv",
        "kzengi": "Kzengi",
        "kzyl-bajrak": "Kzyl-Bajrak",
        "l-aquila": "L'Aquila",
        "la-ceiba": "La Ceiba",
        "la-punt-chamues-ch": "La Punt Chamues-ch",
        "laane-harju-vald": "Lääne-Harju vald",
        "ladenburg": "Ladenburg",
        "lagos": "Lagos",
        "laguna-hills": "Laguna Hills",
        "lahore": "Lahore",
        "langenbach": "Langenbach",
        "langenfeld": "Langenfeld",
        "larnaca": "Larnaca",
        "las-palmas-de-gran-canaria": "Las Palmas de Gran Canaria",
        "las-vegas": "Las Vegas",
        "laufen": "Laufen",
        "lausanne": "Lausanne",
        "legian": "Legian",
        "leh": "Leh",
        "leipzig": "Leipzig",
        "leoben": "Leoben",
        "lesa": "Lesa",
        "leuven": "Leuven",
        "lilienthal": "Lilienthal",
        "lille": "Lille",
        "lima": "Lima",
        "limassol": "Limassol",
        "limassol-municipality": "Limassol Municipality",
        "linkoping": "Linköping",
        "lipezk": "Lipezk",
        "lisboa": "Lisboa",
        "lisbon": "Lisbon",
        "ljubljana": "Ljubljana",
        "lobnya": "Lobnya",
        "london": "London",
        "los-angeles": "Los Angeles",
        "los-gatos": "Los Gatos",
        "loudon": "Loudon",
        "loxstedt": "Loxstedt",
        "lucerne": "Lucerne",
        "lucknow": "Lucknow",
        "lugano": "Lugano",
        "lund": "Lund",
        "luneburg": "Lüneburg",
        "luxembourg": "Luxembourg",
        "lviv": "Lviv",
        "lytkarino": "Lytkarino",
        "lyubertsy": "Lyubertsy",
        "madison": "Madison",
        "madrid": "Madrid",
        "magnitogorsk": "Magnitogorsk",
        "mainz": "Mainz",
        "malaga": "Málaga",
        "malden": "Malden",
        "malmo": "Malmo",
        "manchester": "Manchester",
        "manhattan-beach": "Manhattan Beach",
        "manila": "Manila",
        "mannheim": "Mannheim",
        "mansfield": "Mansfield",
        "maqawwarah": "Maqawwarah",
        "marina-del-rey": "Marina del Rey",
        "marrakech": "Marrakech",
        "massachusetts-gore": "Massachusetts Gore",
        "medan": "Medan",
        "melbourne": "Melbourne",
        "mellieha": "Mellieha",
        "merida": "Mérida",
        "metz": "Metz",
        "mexico": "Mexico",
        "mexico-city": "Mexico City",
        "miami": "Miami",
        "milan": "Milan",
        "milton-keynes": "Milton Keynes",
        "milwaukee": "Milwaukee",
        "mirzo-ulugbek": "Mirzo Ulugbek",
        "modi-in-illit": "Modi'in Illit",
        "mojacar": "Mojácar",
        "monaco": "Monaco",
        "montabaur": "Montabaur",
        "montevideo": "Montevideo",
        "montijo": "Montijo",
        "montreal": "Montreal",
        "montreux": "Montreux",
        "morgantown": "Morgantown",
        "moskau": "Moscow",
        "moscou": "Moscou",
        "moscow": "Moscow",
        "mosrentgen": "Mosrentgen",
        "mumbai": "Mumbai",
        "munchen": "München",
        "munich": "Munich",
        "municipality-of-vrilissia": "Municipality of Vrilissia",
        "munster": "Münster",
        "murnau-am-staffelsee": "Murnau am Staffelsee",
        "muscat": "Muscat",
        "mytishchi": "Mytishchi",
        "nadupatti": "Nadupatti",
        "nairobi": "Nairobi",
        "namangan": "Namangan",
        "naples": "Naples",
        "narromine-shire-council": "Narromine Shire Council",
        "nashville": "Nashville",
        "navi-mumbai": "Navi Mumbai",
        "netanya": "Netanya",
        "neuchatel": "Neuchâtel",
        "neuhausen": "Neuhausen",
        "new-city": "New City",
        "new-delhi": "New Delhi",
        "new-orleans": "New Orleans",
        "new-york": "New York",
        "newark": "Newark",
        "newcastle-city-council": "Newcastle City Council",
        "newfields": "Newfields",
        "newport-news": "Newport News",
        "newton": "Newton",
        "nezahualcoyotl": "Nezahualcóyotl",
        "nha-trang": "Nha Trang",
        "nice": "Nice",
        "nicosia": "Nicosia",
        "nijmegen": "Nijmegen",
        "nilufer": "Nilüfer",
        "nizhny-novgorod": "Nizhny Novgorod",
        "noginsk": "Noginsk",
        "noicattaro": "Noicattaro",
        "north-potomac": "North Potomac",
        "northampton": "Northampton",
        "nossen": "Nossen",
        "nottingham": "Nottingham",
        "novi-sad": "Novi Sad",
        "novocheboksarsk": "Novocheboksarsk",
        "novosibirsk": "Novosibirsk",
        "nuevo-mexico": "Nuevo México",
        "nuremberg": "Nuremberg",
        "nurnberg": "Nürnberg",
        "nyon": "Nyon",
        "obninsk": "Obninsk",
        "ocosingo": "Ocosingo",
        "odesa": "Odesa",
        "odintsovo": "Odintsovo",
        "ohio": "Ohio",
        "ohrid": "Ohrid",
        "okinawa": "Okinawa",
        "okres-brno-mesto": "okres Brno-město",
        "old-tappan": "Old Tappan",
        "oldenburg": "Oldenburg",
        "olympia": "Olympia",
        "onex": "Onex",
        "onna": "Onna",
        "orange": "Orange",
        "orlando": "Orlando",
        "osaka": "Osaka",
        "oshogbo": "Oshogbo",
        "oslo": "Oslo",
        "osnabruck": "Osnabrück",
        "osterholz-scharmbeck": "Osterholz-Scharmbeck",
        "ostfildern": "Ostfildern",
        "ottawa": "Ottawa",
        "oxford": "Oxford",
        "oyo": "Oyo",
        "oyon": "Oyón",
        "oyten": "Oyten",
        "paderborn": "Paderborn",
        "padua": "Padua",
        "pafos": "Pafos",
        "palma-de-mallorca": "Palma de Mallorca",
        "palo-alto": "Palo Alto",
        "pamukkale": "Pamukkale",
        "pancevo": "Pančevo",
        "paphos": "Paphos",
        "paris": "Paris",
        "pasadena": "Pasadena",
        "passau": "Passau",
        "pavlovsky-posad": "Pavlovsky Posad",
        "peliatan": "Peliatan",
        "perm": "Perm",
        "perugia": "Perugia",
        "peshawar": "Peshawar",
        "petaling-jaya": "Petaling Jaya",
        "peterborough": "Peterborough",
        "pfafers": "Pfäfers",
        "philadelphia": "Philadelphia",
        "phoenix": "Phoenix",
        "phuket": "Phuket",
        "pisa": "Pisa",
        "piscataway-township": "Piscataway Township",
        "pittsburgh": "Pittsburgh",
        "playa-del-carmen": "Playa del Carmen",
        "podgorica": "Podgorica",
        "port-harcourt": "Port Harcourt",
        "portimao": "Portimão",
        "portland": "Portland",
        "porto": "Porto",
        "porto-alegre": "Porto Alegre",
        "portsmouth": "Portsmouth",
        "potsdam": "Potsdam",
        "poznan": "Poznan",
        "prague": "Prague",
        "praha": "Praha",
        "preston": "Preston",
        "prilep": "Prilep",
        "princeton": "Princeton",
        "protvino": "Protvino",
        "pskov": "Pskov",
        "puebla-city": "Puebla City",
        "pune": "Pune",
        "punta-del-este": "Punta del Este",
        "pushchino": "Pushchino",
        "pushkino": "Pushkino",
        "pyatigorsk": "Pyatigorsk",
        "płonina": "Płonina",
        "qarshi": "Qarshi",
        "qashqar-mahalla": "Qashqar mahalla",
        "queretaro": "Querétaro",
        "quincy": "Quincy",
        "quintana-roo": "Quintana Roo",
        "rabat": "Rabat",
        "rajkot": "Rajkot",
        "raleigh": "Raleigh",
        "ramat-gan": "Ramat Gan",
        "ras-al-khaimah": "Ras Al Khaimah",
        "ratanpur": "Ratanpur",
        "reading": "Reading",
        "redcar": "Redcar",
        "redmond": "Redmond",
        "redondo-beach": "Redondo Beach",
        "regensburg": "Regensburg",
        "reggio-nell-emilia": "Reggio nell'Emilia",
        "rehovot": "Rehovot",
        "reisterstown": "Reisterstown",
        "reutlingen": "Reutlingen",
        "richmond": "Richmond",
        "richmond-hill": "Richmond Hill",
        "riga": "Riga",
        "rio-de-janeiro": "Rio de Janeiro",
        "rishon-lezion": "Rishon LeZion",
        "riyadh": "Riyadh",
        "rochester": "Rochester",
        "rome": "Rome",
        "romont-fr": "Romont FR",
        "roseville": "Roseville",
        "rossano-veneto": "Rossano Veneto",
        "rostock": "Rostock",
        "rostov-on-don": "Rostov-on-Don",
        "rotterdam": "Rotterdam",
        "rourkela": "Rourkela",
        "rsovci": "Rsovci",
        "rue": "Rue",
        "ruza": "Ruza",
        "ryazan": "Ryazan",
        "rybinsk": "Rybinsk",
        "saarbrucken": "Saarbrücken",
        "saavedra": "Saavedra",
        "sacramento": "Sacramento",
        "saddle-river": "Saddle River",
        "safi": "Safi",
        "saint-petersburg": "Saint Petersburg",
        "salerno": "Salerno",
        "salt-lake-city": "Salt Lake City",
        "samara": "Samara",
        "samarkand": "Samarkand",
        "san-carlos-de-bariloche": "San Carlos de Bariloche",
        "san-diego": "San Diego",
        "san-francisco": "San Francisco",
        "san-isidro": "San Isidro",
        "san-jose": "San Jose",
        "san-jose-de-ushua": "San José de Ushua",
        "san-leandro": "San Leandro",
        "san-marino": "San Marino",
        "san-sebastian": "San Sebastián",
        "santa-ana": "Santa Ana",
        "santa-barbara": "Santa Barbara",
        "santa-clara": "Santa Clara",
        "santa-cruz-de-la-sierra": "Santa Cruz de la Sierra",
        "santiago": "Santiago",
        "santiago-de-queretaro": "Santiago de Querétaro",
        "sao-joao-estoril": "São João do Estoril",
        "sao-paulo": "São Paulo",
        "sapporo": "Sapporo",
        "sarasota": "Sarasota",
        "satellite-beach": "Satellite Beach",
        "schaffhausen": "Schaffhausen",
        "schaumburg": "Schaumburg",
        "schleswig": "Schleswig",
        "schwerin": "Schwerin",
        "se": "Sé",
        "seattle": "Seattle",
        "seeheim-jugenheim": "Seeheim-Jugenheim",
        "senwabarwana": "Senwabarwana",
        "seoul": "Seoul",
        "serpukhov": "Serpukhov",
        "settat": "Settat",
        "sfax": "Sfax",
        "shantou": "Shantou",
        "sharjah": "Sharjah",
        "shenzhen": "Shenzhen",
        "sherborn": "Sherborn",
        "siegen": "Siegen",
        "siena": "Siena",
        "silchar": "Silchar",
        "simferopol": "Simferopol",
        "singapore": "Singapore",
        "sisli": "Şişli",
        "skopje": "Skopje",
        "smolensk": "Smolensk",
        "sochi": "Sochi",
        "sofia": "Sofia",
        "solingen": "Solingen",
        "somerville": "Somerville",
        "sopot": "Sopot",
        "squamish": "Squamish",
        "st-albans": "St Albans",
        "st-gallen": "St. Gallen",
        "st-louis": "St. Louis",
        "st-sulpice-vd": "St-Sulpice VD",
        "stadtgebiet-bremen": "Stadtgebiet Bremen",
        "staines-upon-thames": "Staines-upon-Thames",
        "stari-grad-urban-municipality": "Stari Grad Urban Municipality",
        "stavanger": "Stavanger",
        "stavropol": "Stavropol",
        "stockholm": "Stockholm",
        "stralsund": "Stralsund",
        "strasbourg": "Strasbourg",
        "straubing": "Straubing",
        "stupino": "Stupino",
        "stuttgart": "Stuttgart",
        "sudbury": "Sudbury",
        "sudwest-fryslan": "Súdwest-Fryslân",
        "sultan-bathery": "Sultan Bathery",
        "sunny-isles-beach": "Sunny Isles Beach",
        "sunnyvale": "Sunnyvale",
        "surgut": "Surgut",
        "suwon": "Suwon",
        "svetlogorsk": "Svetlogorsk",
        "swansea": "Swansea",
        "swindon": "Swindon",
        "sydney": "Sydney",
        "taguig": "Taguig",
        "taipei": "Taipei",
        "taiwang": "Taiwang",
        "tallinn": "Tallinn",
        "tampa": "Tampa",
        "tampere": "Tampere",
        "tashkent": "Tashkent",
        "tbilisi": "Tbilisi",
        "teays-valley": "Teays Valley",
        "tehran": "Tehran",
        "tel-aviv": "Tel Aviv",
        "tel-izhak": "Tel Izhak",
        "termez": "Termez",
        "terrassa": "Terrassa",
        "tertry": "Tertry",
        "texas-city": "Texas City",
        "thanh-pho-ho-chi-minh": "Thành phố Hồ Chí Minh",
        "the-hague": "The Hague",
        "theoule-sur-mer": "Théoule-sur-Mer",
        "thonon-les-bains": "Thonon-les-Bains",
        "three-rivers": "Three Rivers",
        "thuwal": "Thuwal",
        "tibubeneng": "Tibubeneng",
        "tilburg": "Tilburg",
        "tirana": "Tirana",
        "titel-municipality": "Titel Municipality",
        "tivat": "Tivat",
        "tlalnepantla": "Tlalnepantla",
        "togliatti": "Togliatti",
        "tokyo": "Tokyo",
        "tolyatti": "Tolyatti",
        "tonisvorst": "Tönisvorst",
        "toronto": "Toronto",
        "torres-vedras": "Torres Vedras",
        "torrevieja": "Torrevieja",
        "toshkent": "Toshkent",
        "toulon": "Toulon",
        "toulouse": "Toulouse",
        "town-of-eastchester": "Town of Eastchester",
        "tres-arroyos": "Tres Arroyos",
        "trieste": "Trieste",
        "tubingen": "Tübingen",
        "tulsa": "Tulsa",
        "tunis": "Tunis",
        "turin": "Turin",
        "tuscania": "Tuscania",
        "tver": "Tver",
        "twin-falls": "Twin Falls",
        "tyumen": "Tyumen",
        "ua-pou": "Ua Pou",
        "ubud": "Ubud",
        "udine-udin": "Udine / Udin",
        "ufa": "Ufa",
        "ulaanbaatar": "Ulaanbaatar",
        "ulm": "Ulm",
        "upper-darby": "Upper Darby",
        "uppsala": "Uppsala",
        "urgench": "Urgench",
        "us": "Us",
        "us-coast-guard-reservation": "US Coast Guard Reservation",
        "ussy": "Ussy",
        "utrecht": "Utrecht",
        "uttar-mohal": "Uttar Mohal",
        "uyo": "Uyo",
        "uz": "Uz",
        "uzbekistan": "Uzbekistan",
        "vaasa": "Vaasa",
        "vadodara": "Vadodara",
        "valencia": "Valencia",
        "vancouver": "Vancouver",
        "vannes": "Vannes",
        "varna": "Varna",
        "vaughan": "Vaughan",
        "veldhoven": "Veldhoven",
        "veliko-tarnovo": "Veliko Tarnovo",
        "veliky-novgorod": "Veliky Novgorod",
        "venezia": "Venezia",
        "veracruz-city": "Veracruz City",
        "vienna": "Vienna",
        "vigo": "Vigo",
        "villers-brulin": "Villers-Brûlin",
        "vilnius": "Vilnius",
        "viru-nigula": "Viru-Nigula",
        "visp": "Visp",
        "vista-hermosa": "Vista Hermosa",
        "vladikavkaz": "Vladikavkaz",
        "vladimir": "Vladimir",
        "vojvodinci": "Vojvodinci",
        "vologda": "Vologda",
        "voronezh": "Voronezh",
        "vozdovac-urban-municipality": "Vozdovac Urban Municipality",
        "walldorf": "Walldorf",
        "warsaw": "Warsaw",
        "warwick": "Warwick",
        "washington": "Washington",
        "wassenaar": "Wassenaar",
        "waverley": "Waverley",
        "weiterstadt": "Weiterstadt",
        "wesel": "Wesel",
        "west-jerusalem": "West Jerusalem",
        "west-oxfordshire": "West Oxfordshire",
        "wien": "Wien",
        "wiesbaden": "Wiesbaden",
        "wilbraham": "Wilbraham",
        "winnipeg": "Winnipeg",
        "winterthur": "Winterthur",
        "woking": "Woking",
        "wolverhampton": "Wolverhampton",
        "worms": "Worms",
        "woudenberg": "Woudenberg",
        "wrocław": "Wrocław",
        "wurzburg": "Würzburg",
        "xi-an": "Xi'an",
        "xorezm": "Xorezm",
        "yangibazar": "Yangibazar",
        "yangiyul": "Yangiyul",
        "yaroslavl": "Yaroslavl",
        "yekaterinburg": "Yekaterinburg",
        "yerevan": "Yerevan",
        "zagreb": "Zagreb",
        "zelenograd": "Zelenograd",
        "zemun-urban-municipality": "Zemun Urban Municipality",
        "zhukovsky": "Zhukovsky",
        "zollikerberg": "Zollikerberg",
        "zug": "Zug",
        "zurich": "Zurich",
        "zvenigorod": "Zvenigorod",
        "đa-nang": "Đà Nẵng",
        "λαρνακα": "Λάρνακα",
        "λεμεσος": "Λεμεσός",
        "παφος": "Πάφος",
        "алматы": "Алматы",
        "алматы-ауылдық-округі": "Алматы ауылдық округі",
        "астана": "Астана",
        "белоградчик": "Белоградчик",
        "београд": "Београд",
        "бишкек": "Бишкек",
        "град-нови-сад": "Град Нови Сад",
        "градска-општина-вождовац": "Градска општина Вождовац",
        "градска-општина-земун": "Градска општина Земун",
        "долгопрудныи": "Долгопрудный",
        "душанбе": "Душанбе",
        "екатеринбург": "Екатеринбург",
        "ижевск": "Ижевск",
        "казань": "Казань",
        "калининград": "Калининград",
        "королев": "Королёв",
        "краснодар": "Краснодар",
        "краснознаменск": "Краснознаменск",
        "лобня": "Лобня",
        "менеуз-москва": "Менеуз-Москва",
        "моика": "Мойка",
        "москва": "Москва",
        "мытищи": "Мытищи",
        "нови-сад": "Нови Сад",
        "новосибирск": "Новосибирск",
        "одинцово": "Одинцово",
        "покровское": "Покровское",
        "ростов-на-дону": "Ростов-на-Дону",
        "самара": "Самара",
        "санкт-петербург": "Санкт-Петербург",
        "светлогорск": "Светлогорск",
        "светлыи": "Светлый",
        "смоленск": "Смоленск",
        "советск": "Советск",
        "софия": "София",
        "сочи": "Сочи",
        "тамбов": "Тамбов",
        "тбилисское-сельское-поселение": "Тбилисское сельское поселение",
        "тверь": "Тверь",
        "томск": "Томск",
        "ульяновск": "Ульяновск",
        "уфа": "Уфа",
        "ялта": "Ялта",
        "ярославль": "Ярославль",
        "әлжан-ана": "Әлжан ана",
        "երեւան": "Երևան",
        "חיפה": "חיפה",
        "ראשון-לציון": "ראשון לציון",
        "רחובות": "רחובות",
        "תל-אביב-יפו": "תל אביב–יפו",
        "ابو-ظبي": "أبو ظبي",
        "الدوحة": "الدوحة",
        "الرياض": "الرياض",
        "حدايق-الشيخ-محمد-بن-راشد-وادي-الصفا-1": "حدائق الشيخ محمد بن راشد/وادي الصفا 1",
        "دبي": "دبي",
        "راس-الخيمة": "رأس الخيمة",
        "ภเก-ต": "ภูเก็ต",
        "თბილისი": "თბილისი",
        "서울특별시": "서울특별시",
        "深圳市": "深圳市",
    },
};
